import React, { useEffect, useState } from "react";

const ReferFriend = () => {
	const [clicked, setClicked] = useState(false);

	useEffect(() => {
		const clickRefer = () => {
			const element = document.querySelector(".lion-loyalty-panel-sidebar__menu-item--refer");
			if (element && !clicked) {
				element.click();
				setClicked(true); 
			}
		};
		const intervalId = setInterval(clickRefer, 1000);

		return () => clearInterval(intervalId);
	}, [clicked]);

	return (
		<div id="refer-a-friend">
			<div data-lion-account></div>
		</div>
	);
};

export default ReferFriend;
